import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import './TS_Toggle.scss';
import { generateHex, voidFunction } from '@nu-art/ts-common';
export class TS_Toggle extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.checked = nextProps.checked;
        state.disabled = nextProps.disabled;
        state.id ??= nextProps.id ?? generateHex(4);
        return state;
    }
    updateCheckedStatus = (e) => {
        // fail fast if disabled
        if (this.state.disabled)
            return;
        // we can assume that knowing the structure of this component
        const checkboxElement = e.currentTarget.children[0];
        return this.props.onCheck(checkboxElement.checked);
    };
    render() {
        const containerClassName = _className('ts-toggle', this.state.disabled && 'disabled', this.props.containerClassName);
        const sliderClassName = _className('ts-toggle__slider', this.state.disabled && 'disabled', this.props.sliderClassName);
        return _jsxs("div", { id: this.state.id, onClick: this.updateCheckedStatus, className: containerClassName, children: [_jsx("input", { onChange: voidFunction, className: 'ts-toggle__checkbox', type: 'checkbox', checked: this.state.checked }), _jsx("label", { htmlFor: this.state.id, className: sliderClassName })] });
    }
}
//# sourceMappingURL=TS_Toggle.js.map